(() => {
  function activate(button) {
    const root = button.closest('.fiole-pdp-experience__mount');
    if (!root) return;
    const mode = button.dataset.fioleTab;
    root.querySelectorAll('[data-fiole-tab]').forEach(tab => {
      const active = tab === button;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[role="tabpanel"]').forEach(panel => {
      panel.hidden = !panel.id.includes('-' + mode + '-');
    });
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-fiole-tab]');
    if (button) activate(button);
  });
  document.addEventListener('keydown', e => {
    const button = e.target.closest('[data-fiole-tab]');
    if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
    const tabs = [...button.closest('.fiole-pdp-experience__mount').querySelectorAll('[data-fiole-tab]')];
    const current = tabs.indexOf(button);
    let next = current;
    if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
    if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') next = 0;
    if (e.key === 'End') next = tabs.length - 1;
    e.preventDefault();
    tabs[next].focus();
    activate(tabs[next]);
  });
})();